module.exports = __webpack_public_path__ + "img/potential1.295a6563.png";